import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
	//APPBASEURLAPI = environment.BASEURL;
	APPBASEURLAPI = window.location.origin+'/admin/FoodDeliverySystem/api_single_res/';
	constructor(private http: HttpClient) { 

	}
  
	getRequest(requestEndpoint,token) {
	let header = new HttpHeaders().set(
	  "token",token
	);
	return this.http.get(this.APPBASEURLAPI+requestEndpoint,{headers:header})
	}

	postRequest(requestEndpoint,obj) {
		var token  = localStorage.getItem('jwt_token');
		if (token==null) {
			token = "";
		}
		let header:any = new HttpHeaders().set(
		  "token", token
		);

		return this.http.post(this.APPBASEURLAPI+requestEndpoint,obj,{headers:header});

	}
}
